const ROTATE = {
    title: `Image Rotator Options`,
    list: [
        {
            icon: `icon__rotator-phone`,
            title: `Rotate image for social media profiles`,
            description: 
                `Rotate digital pictures before uploading them to your social profile on 
                Facebook, Twitter, YouTube, TikTok, Google Ads. Rotate portrait or landscape images online. 
                The tool will keep the original image quality.`
        },
        {
            icon: `icon__settings`,
            title: `Set custom image rotation settings`,
            description: 
                `If you need, you can use our image editor to rotate photo with custom parameters. 
                Rotate image online to a necessary angle, set portrait or landscape orientation. 
                Rotate the pic on a canvas the way you need.`
        },
        {
            icon: `icon__notebook`,
            title: `Rotate images automatically `,
            description: 
                `Image rotator can easily change the default orientation of your pictures. 
                Rotate pictures to any angle in seconds. 
                Simply upload an image and select the desired option.`
        },
        {
            icon: `icon__rotator_option`,
            title: `Rotate images online`,
            description: 
                `Rotator, you can rotate an image on any device for free. 
                Upload image file from a computer, laptop, iPhone or Android smartphone, or tablet. 
                What you need are a web browser and a stable Internet connection.`
        }
    ]
}

const FLIP = {
    title: `Image Flipper Options`,
    list: [
        {
            icon: `icon__flip-options_flip`,
            title: `Flip image for social media profiles`,
            description: 
                `Mirror photos before posting them on Facebook, Twitter, LinkedIn, YouTube, TikTok, Google Ads. 
                Flip image vertically or horizontally online. The tool for mirroring is completely free.`
        },
        {
            icon: `icon__flip-options_automatic`,
            title: `Flip images automatically `,
            description: 
                `Image flipper can easily mirror image horizontally or vertically. 
                Upload an image and select the necessary flipping option. 
                Download the ready photo on your PC or smartphone.`
        },
        {
            icon: `icon__flip-options_custom`,
            title: `Set custom flipping options`,
            description: 
                `Upload an image that you want to mirror to our web service and select one of the mirroring options. 
                You can flip any image vertically or horizontally. The tool will keep the original quality of your pic.`
        },
        {
            icon: `icon__flip-options_online`,
            title: `Flip images online`,
            description: 
                `With Image Flipper, you can mirror an image on any device completely free. 
                Add pictures from your PC, smartphone, or tablet. 
                Flip the image horizontally or vertically and download the flipped image.`
        }
    ]
}

const CROPPER = {
    title: `Image Cropper Features`,
    list: [
        {
            icon: `icon__like`,
            title: `Prepare photos for any social media platform`,
            description: 
                `Crop pictures before uploading them to your social media profile. 
                The tool will keep the original quality of your image. 
                Crop photos for Facebook, Instagram, LinkedIn, Google, etc.`
        },
        {
            icon: `icon__notebook`,
            title: `Crop your images automatically `,
            description: 
                `Use the ready templates to crop image without dealing with settings. 
                You don't need to be a computer geek. Simply upload a photo and let the tool do the job for you.`
        },
        {
            icon: `icon__gear`,
            title: `Select custom settings`,
            description: 
                `If you need, you can edit cropping parameters manually. 
                Change orientation, set custom size in pixels, aspect ratio, and add photo effects. 
                Crop as many pictures as you like.`
        },
        {
            icon: `icon__resize`,
            title: `Crop images online`,
            description: 
                `Use image cropper on any device for free. Upload files from a PC, laptop, smartphone, or tablet. 
                You only need a web browser and a stable Internet connection.`
        }
    ]
}

export default function getContantPage(service: string) {
    switch (service) {
      case 'rotator': return ROTATE;
      case 'flipper': return FLIP;
      case 'cropper': return CROPPER;
      default:
        return {
          title: '',
          list: []
        };      
    }
  
  }
  